import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core'
import { FormGroup, ReactiveFormsModule } from '@angular/forms'
import { CommercialGeneralLiabilityForm } from '../../../models/coverages/base-coverage.model'
import { COMMERCIAL_GENERAL_LIABILITY_PANELS } from '../../../models/coverages/coverage-panels.model'
import { SubCoveragePanelsComponent } from '../sub-coverage-panels/sub-coverage-panels.component'
import { Accordion } from 'primeng/accordion'
import { InsuredBaseForm } from '../../insured-base-form.directive'
import { DetailviewNavigationService } from '@services/detailview-navigation.service'

/**
 * Commercial General Liability coverage form: one panel per CGL sub-coverage.
 *
 * @example
 * <albert-commercial-general-liability-form [form]="cglForm" [isCreateMode]="false" [mainIndex]="4" />
 */
@Component({
  selector: 'albert-commercial-general-liability-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    SubCoveragePanelsComponent,
    Accordion
  ],
  templateUrl: './commercial-general-liability-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommercialGeneralLiabilityFormComponent extends InsuredBaseForm<CommercialGeneralLiabilityForm> {
  /** Coverage form group, owned by the insured detailview */
  public override readonly form = input.required<FormGroup<CommercialGeneralLiabilityForm>>()
  /** Position of this coverage in the detailview's sections, used to match nav targets */
  public readonly mainIndex = input<number>()

  public readonly nav = inject(DetailviewNavigationService)

  protected readonly panels = COMMERCIAL_GENERAL_LIABILITY_PANELS

  constructor() {
    super()
    this.setupPanelNavigationEffects(
      this.nav,
      this.mainIndex,
      this.panels.map(panel => panel.key)
    )
  }

  protected override getFormGroup(): FormGroup<CommercialGeneralLiabilityForm> {
    return this.form()
  }
}
